import request from '@/utils/request'
import { AFR_API, BASE_API } from '@/const'
import useBaseStore from '@/store/useBaseStore'

/**
 * @description: 获取发货地
 * @return {Promise<[]>}
 */
export const fetchReceiptPorts = async (keyword = ''): Promise<any[]> => {
  const baseStore = useBaseStore()
  const res = await request<any[]>(
    `/portal/common/ports/s?keyword=${keyword}&product=${baseStore.getProductCode}`,
    {
      baseURL: AFR_API,
    },
  )
  return (
    res.data?.map((item) => {
      return {
        ...item,
        label: item.display,
        value: item.fiveCode,
      }
    }) || []
  )
}

/**
 * @description: 获取交货地
 * @return {Promise<[]>}
 */
export const fetchDeliveryPorts = async (keyword = ''): Promise<any[]> => {
  const baseStore = useBaseStore()
  const res = await request<any[]>(
    `/portal/common/ports/s?keyword=${keyword}&product=${baseStore.getProductCode}`,
    {
      baseURL: AFR_API,
    },
  )
  return (
    res.data?.map((item) => {
      return {
        ...item,
        label: item.display,
        value: item.fiveCode,
      }
    }) || []
  )
}

/**
 * @description: 获取收货地交货地常用港口
 * @param type
 *  MPCI_PORT_LOADING -- 装货港
 *  MPCI_PORT_DISCHARGE -- 卸货港
 *  MPCI_PORT_RECEIPT -- 收货地
 *  MPCI_PORT_DELIVERY -- 交货地
 * @return {Promise<[]>}
 */
export const fetchCommonPorts = async (
  type:
    | 'MPCI_PORT_LOADING'
    | 'MPCI_PORT_DISCHARGE'
    | 'MPCI_PORT_RECEIPT'
    | 'MPCI_PORT_DELIVERY',
): Promise<any[]> => {
  const baseStore = useBaseStore()
  const res = await request<any[]>(
    `/portal/common/ports/frequently?type=${type}&product=${baseStore.getProductCode}`,
    {
      baseURL: AFR_API,
    },
  )
  return (
    res.data?.map((item) => {
      return {
        ...item,
        label: item.display,
        value: item.fiveCode,
      }
    }) || []
  )
}
